import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { getEmergingAI } from "../services/dashboardService";
import { fetchCurrentJobDescription } from "../services/profileService";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentJobDescription } from "../redux/userSlice";

const useEmergingAI = (currentJob) => {
  const { currentJobDescription, occupationId } = useSelector((state) => state.user);
  const { lightcastToken } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  
  useEffect(() => {
    const fetchDescription = async () => {
      if (!currentJobDescription && occupationId && lightcastToken) {
        try {
          const description = await fetchCurrentJobDescription(occupationId, lightcastToken);
          if (description) {
            dispatch(setCurrentJobDescription(description));
          }
        } catch (error) {
          console.error('❌ Error fetching currentJobDescription:', error);
        }
      }
    };
    
    fetchDescription();
  }, [currentJobDescription, occupationId, lightcastToken, dispatch]);
  
  
  
  return useQuery({
    queryKey: ["emergingAIGraph", currentJob, occupationId, currentJobDescription], // Shared cache key across components
    queryFn: () => getEmergingAI(occupationId, currentJob, currentJobDescription),
    enabled: !!currentJob && !!occupationId && !!currentJobDescription, // Wait for currentJobDescription to be fetched
    staleTime: Infinity, // Keeps data fresh until manually invalidated
    cacheTime: Infinity, // Persist data even if no components are using it
    onError: (error) => {
      console.error("Error:", error.response?.data || error.message);
    },
  });
};

export default useEmergingAI;
